// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ks39CcIClRgcEH {
  display: flex;
  position: relative;
  flex-flow: row;
  justify-content: space-between;
  min-height: 40px;
  padding: var(--ds-space-150, 12px) var(--ds-space-0, 0);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.ks39CcIClRgcEH .BysWQhAJOH3tUS {
  display: block;
  position: relative;
  z-index: 0;
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  margin: var(--ds-space-050, 4px) var(--ds-space-100, 8px) var(--ds-space-0, 0) var(--ds-space-050, 4px);
  overflow: visible;
  border-radius: 25em;
  background-color: var(--ds-background-neutral, #091e420f);
  color: var(--ds-text, #172b4d);
  text-decoration: none;
  -webkit-user-select: none;
  user-select: none;
}
.ks39CcIClRgcEH .BysWQhAJOH3tUS .US5g2y9hEy0OJu {
  width: 32px;
  height: 32px;
  border-radius: 25em;
  object-fit: cover;
}
.ks39CcIClRgcEH .BysWQhAJOH3tUS .Ul9RSu7xZwQzFd {
  display: block;
  position: absolute;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 100%;
  height: 32px;
  overflow: hidden;
  font-size: 12px;
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 32px;
  text-align: center;
}
.ks39CcIClRgcEH .IOlSeKg3XUUFtN {
  flex: 1;
  width: 160px;
}
.ks39CcIClRgcEH .IOlSeKg3XUUFtN .PPIoGqRZSCkdKr {
  margin-right: var(--ds-space-050, 4px);
  margin-bottom: var(--ds-space-0, 0);
  overflow: hidden;
  font-size: 16px;
  font-weight: var(--ds-font-weight-bold, bold);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ks39CcIClRgcEH .IOlSeKg3XUUFtN .Mzy_U5kPWjRUnE {
  margin-bottom: var(--ds-space-0, 0);
  padding-bottom: var(--ds-space-0, 0);
  overflow: hidden;
  color: var(--ds-text-subtle, #44546f);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ks39CcIClRgcEH .jS_jUHaePJvnkl {
  max-height: 32px;
  margin: auto;
  padding-left: var(--ds-space-200, 16px);
}
.ks39CcIClRgcEH .P45ScytJ0lMc9R {
  min-width: 95px;
  max-height: 32px;
  margin: var(--ds-space-0, 0);
}
.r8FNOgwJX1J6hc {
  display: flex;
  justify-content: center;
  width: 100%;
}
.hmcVdvl7YlAIi1 {
  border-bottom: 1px solid var(--ds-border, #091e4224);
  min-height: 40px;
  padding: var(--ds-space-150, 12px) var(--ds-space-0, 0);
}
.KSHjfujmP34opZ {
  border-top: 1px solid var(--ds-border, #091e4224);
}
.ZdqNBNDtgJbXrJ {
  margin-bottom: var(--ds-space-100, 8px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"memberItem": `ks39CcIClRgcEH`,
	"memberAvatar": `BysWQhAJOH3tUS`,
	"memberImage": `US5g2y9hEy0OJu`,
	"memberInitials": `Ul9RSu7xZwQzFd`,
	"memberDetails": `IOlSeKg3XUUFtN`,
	"memberFullName": `PPIoGqRZSCkdKr`,
	"memberUsername": `Mzy_U5kPWjRUnE`,
	"memberOption": `jS_jUHaePJvnkl`,
	"memberRemoveButton": `P45ScytJ0lMc9R`,
	"spinnerContainer": `r8FNOgwJX1J6hc`,
	"memberItemSpinner": `hmcVdvl7YlAIi1`,
	"membersList": `KSHjfujmP34opZ`,
	"addCollaboratorsButton": `ZdqNBNDtgJbXrJ`
};
export default ___CSS_LOADER_EXPORT___;
